export default "__VITE_ASSET__BPBmj7Eo__"